import * as Yup from "yup";

export const FormModalSchema = Yup.object().shape({
  name: Yup.string().required("Required").trim(),

  key: Yup.string().required("Required").trim(),

  // parentId: Yup.mixed().when("isPage", {
  //   is: true,
  //   then: (schema) => schema.required("Required"),
  //   otherwise: (schema) => schema.nullable().transform(() => null),
  // }),

  path: Yup.string().when("isPage", {
    is: true,
    then: (schema) => schema.required("Required"),
    otherwise: (schema) => schema.nullable().transform(() => null),
  }),

  displayIndex: Yup.string().required("Required"),

  description: Yup.string()
    .nullable()
    .optional()
    .max(200, "Description must not exceed 200 characters")
    .trim(),

  permissions: Yup.mixed().nullable().optional(),
});

export const RolesModalSchema = Yup.object().shape({
  name: Yup.string().required("Required").trim(),
  key: Yup.string().required("Required").trim(),
  parentId: Yup.mixed().required("Required"),
  formPermissions: Yup.array()
    .min(1, "Select At least 1 Form")
    .required("Select At least 1 Form"),
});
